import { WEBHOOKS } from '../actionTypes';

const initialState = {
  content: [],
  webhookEvents: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case WEBHOOKS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case WEBHOOKS.EVENTS_SUCCESS:
      return {
        ...state,
        webhookEvents: action.payload,
      };
    default:
      return state;
  }
};
